function handleWidgetsCountClass (root) {
  const list = root.querySelectorAll('.hotel-info__location, .weather-widget, .offerFreebies')
  const newOfferWidget = root.querySelector('.hotel-info__location')
  if (newOfferWidget && list.length == 3) newOfferWidget.classList.add('three-rows')
}

export function init () {
  const root = document.querySelector('.offer-content__widgets')
  if (root) handleWidgetsCountClass(root.lastElementChild)
}


// WEBPACK FOOTER //
// ./src/modules/offerWidgets.js